import React from 'react';
import Hero from '../../components/Hero/Hero';
import DestinationCard from '../../components/DestinationCard/DestinationCard';
import { destinations } from '../../data/destinations';
import './Home.css';

const Home = () => {
  // show 2 popular destinations per continent
  const continents = Array.from(new Set(destinations.map(d => d.location).filter(Boolean)));
  const featuredDestinations = continents.flatMap(cont =>
    destinations.filter(d => d.location === cont).slice(0, 2)
  );

  return (
    <div className="home">
      <Hero />
      
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Destinations Populaires</h2>
            <p>Découvrez nos destinations les plus prisées à travers le monde</p>
          </div>
          
          <div className="grid grid-3">
            {featuredDestinations.map(destination => (
              <DestinationCard key={destination.id} destination={destination} />
            ))}
          </div>
          
          <div className="section-cta">
            <button className="btn btn-primary">Voir toutes les destinations</button>
          </div>
        </div>
      </section>

      <section className="section section-features">
        <div className="container">
          <div className="grid grid-3">
            <div className="feature-card">
              <div className="feature-icon">🌎</div>
              <h3>Global</h3>
              <p>Plus de 100 destinations à travers le monde entier</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💰</div>
              <h3>Meilleur Prix</h3>
              <p>Garantie du meilleur prix ou nous remboursons la différence</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⭐</div>
              <h3>Expertise</h3>
              <p>15 ans d'expérience dans l'organisation de voyages</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;